import React, { Component } from "react";

import { connect } from "react-redux";
import ReduxToastr from "react-redux-toastr";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";

import AllocationFinder from "./AllocationFinder";
import ExternalAuth from "./ExternalAuth";
import ChangePassword from "./ForgotPassword";
import Guest from "./Guest";
import Login from "./Login";
import LoginExternal from "./Login/LoginExternal";
import Logout from "./Logout";
import { connectToSocket } from "../actions/baseActions";
import URL from "../config/api";
import axios from "../config/axios";
import Main from "../layout/Main";

import "./styles.css";
import "../scss/_variables.scss";
import "../scss/_main.scss";

class Root extends Component {
  constructor(props) {
    super(props);

    this.state = {
      routes: [],
      guestRoutes: [],
      logged: this.props.general.logged
    };
  }

  async checkAndGetRoutesIfLogged() {
    const { logged } = this.props.general;
    const id = this.props.general.active_roles.group_id;

    if (logged) {
      this.props.connectToSocket();

      let rawRoutes = this.props.general.routes;

      if (rawRoutes.length === 0) {
        const res = await axios.get(`${URL.api}routes`);
        rawRoutes = res.data.data;
      }

      let routes = rawRoutes.map(menu => {
        try {
          let component = require(`../pages/${menu.local}`).default;

          return {
            path: menu.path,
            name: menu.name,
            component,
            exact: menu.exact,
            id: menu.id,
            hideLayout:
              component.WrappedComponent.defaultProps?.hideLayout || false,
            guestLogin:
              component.WrappedComponent.defaultProps?.guestLogin || false
          };
        } catch (err) {
          return {
            path: "./Dashboard",
            name: menu.name,
            component: <Redirect to="/" />,
            exact: menu.exact,
            id: menu.id,
            hideLayout: false,
            guestLogin: false
          };
        }
      });

      this.setState({
        routes: routes.filter(route => route.hideLayout === true),
        guestRoutes: routes.filter(route => route.guestLogin === true)
      });
    }
  }

  async componentDidMount() {
    this.checkAndGetRoutesIfLogged();
  }

  componentDidUpdate(prevProps) {
    // Check if the logged state has changed
    if (
      prevProps.general.logged !== this.props.general.logged &&
      this.props.general.logged === false
    ) {
      setTimeout(() => {
        this.setState(
          {
            logged: this.props.general.logged
          },
          () => {
            this.checkAndGetRoutesIfLogged();
          }
        );
      }, 1000);
    } else if (prevProps.general.logged !== this.props.general.logged) {
      this.setState(
        {
          logged: this.props.general.logged
        },
        () => {
          this.checkAndGetRoutesIfLogged();
        }
      );
    }
  }

  render() {
    const { logged } = this.props.general;

    return (
      <div>
        <ReduxToastr />
        <BrowserRouter>
          {this.state.logged ? (
            <Switch>
              {this.state.routes.map(
                (route, idx) =>
                  route.component && (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={props => (
                        <route.component currentRoute={route.id} {...props} />
                      )}
                    />
                  )
              )}
              <Route
                path="/external_auth"
                name="External Auth"
                component={ExternalAuth}
              />
              <Route path="/" name="Home" component={Main} />
            </Switch>
          ) : (
            <Switch>
              {this.state.guestRoutes.map(
                (route, idx) =>
                  route.component && (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      component={Guest}
                    />
                  )
              )}
              <Route
                path="/allocationFinder/:activity_id"
                name="Allocation Finder"
                component={AllocationFinder}
              />
              <Route
                path="/external_auth"
                name="External Auth"
                component={ExternalAuth}
              />
              <Route path="/logout" name="Logout" component={Logout} />
              <Route
                path="/changepassword/:token/:email"
                name="Change Password"
                component={ChangePassword}
              />
              <Route
                path="/authmn/:token"
                name="External Login"
                component={LoginExternal}
              />
              <Route path="/" name="Login Page" component={Login} />
            </Switch>
          )}
          {/* <VLibras /> */}
        </BrowserRouter>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      connectToSocket
    },
    dispatch
  );
}

const mapStateToProps = state => ({ general: state.general, user: state.user });

export default connect(mapStateToProps, mapDispatchToProps)(Root);
